import React from 'react';
const SaveIcon = ({ size=18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 4h14l2 2v14H4z" />
    <path d="M12 16l4-4H8z" />
    <path d="M8 4v6h8V4" />
  </svg>
);
export default SaveIcon;